export const SUPPORTED_LANGUAGES = [
  { code: 'en-US', displayCode: 'en', name: 'English' },
  { code: 'ja-JP', displayCode: 'ja', name: '日本語' },
  { code: 'es-ES', displayCode: 'es', name: 'Español' },
] as const

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code']
export type DisplayLanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['displayCode']

const languageMap = new Map(SUPPORTED_LANGUAGES.map((lang) => [lang.displayCode, lang.code]))
const reverseLanguageMap = new Map(SUPPORTED_LANGUAGES.map((lang) => [lang.code, lang.displayCode]))

export const normalizeLanguageCode = (lang: string): LanguageCode => {
  if (isSupportedLanguageCode(lang)) {
    return lang
  }

  const baseCode = lang.split('-')[0].toLowerCase() as DisplayLanguageCode
  const fullCode = languageMap.get(baseCode)

  return fullCode || 'en-US'
}

export const getDisplayLanguageCode = (lang: string): DisplayLanguageCode => {
  const normalized = normalizeLanguageCode(lang)
  return reverseLanguageMap.get(normalized) || 'en'
}

export const isSupportedLanguageCode = (lang: string): lang is LanguageCode => {
  return SUPPORTED_LANGUAGES.some((l) => l.code === lang)
}

export const isSupportedDisplayCode = (lang: string): lang is DisplayLanguageCode => {
  return SUPPORTED_LANGUAGES.some((l) => l.displayCode === lang)
}

export const DEFAULT_LANGUAGE: LanguageCode = 'en-US'
